/**
 * Auth tag to check if user has a role and if true, display child elements.
 * @param props
 * @returns {string}
 * @constructor
 */
function AuthRole(props) {

    let result = '';
    if (props !== undefined && props.user !== undefined && props.role !== undefined) {
        result = userHasRole(props.user, props.role) ? props.children : '';
    }
    return result;
}

/**
 * Function to check if user has a role.
 * @param user
 * @param role
 * @returns {boolean}
 */
function userHasRole(user, role) {

    if (user != null && user.userRoles != null && role != null && user.userRoles.includes(role)) {

        return true;
    }

    return false;
}

/**
 * Auth tag to check if user is part of a group and if true, display child elements.
 * @param props
 * @returns {string}
 * @constructor
 */
function AuthGroup(props) {

    let result = '';
    if (props !== undefined && props.user !== undefined && props.group !== undefined) {
        result = userHasGroupMembership(props.user, props.group) ? props.children : '';
    }
    return result;
}

/**
 * Function to check if user is part of a security group.
 * @param user
 * @param group
 * @returns {boolean}
 */
function userHasGroupMembership(user, group) {

    if (user != null && user.userGroups != null && group != null && user.userGroups.includes(group)) {

        return true;
    }

    return false;
}


export {AuthRole, userHasRole, AuthGroup, userHasGroupMembership}